import React from 'react';
import { AtdwMap } from '../atdw-map-v1/view/atdwMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'AtdwMapTown', 
  itemElt: (item, cmsOption) => <AtdwMap item={item} cmsOption={cmsOption} fromType = {"town"} />
}